module.exports = __webpack_public_path__ + "img/Datum_404.23685fbb.png";